<template>
  <div>
    <v-card
      elevation="1"
      class="card card-mobile"
      flat
      style="margin-left: 3rem; margin-right: 1rem; border-radius: 15px"
    >
      <v-system-bar height="60px" class="card-header-systembar">
        <label
          class="ml-5 my-5"
          style="color: #444444; font-size: 20px !important"
        >
          {{ $t("store") }}
        </label>
      </v-system-bar>

      <v-layout row align-center class="ml-7 mt-10">
        <v-flex xs8 sm6 md6 lg4 xl2>
          <title-block
            :relative="this.$vuetify.breakpoint.name !== 'xs' ? true : false"
            width="300"
            height="60"
            class="report-title-text-mobile"
          >
            {{ $t("store") }}</title-block
          >
        </v-flex>
      </v-layout>
      <v-row class="mt-5 pl-7 pb-5">
        <v-col
          cols="12"
          xs="12"
          sm="12"
          md="4"
          lg="2"
          v-for="(item, i) in cardItems"
          :key="i"
        >
          <v-card
            style="border-radius: 16px"
            height="200"
            @click="$router.push(item.route)"
          >
            <v-card-text justify="center" align="center" style="height: 100%">
              <div class="imgtext"></div>
              <v-img :src="item.image" width="52" class="communityimg"></v-img>
              <p
                class="text-center mt-5"
                style="font-size: 18px; color: #424242"
              >
                {{ item.title }}
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import TitleBlock from "@/components/global_component/TitleBlock";

export default {
  name: "report",
  components: {
    TitleBlock
  },

  data() {
    return {};
  },

  computed: {
    cardItems() {
      return [
        {
          image: require("@/assets/imgs/library_article.svg"),
          title: this.$t("article"),
          name: "Article",
          route: "/dashboard/store/article"
        },
        {
          image: require("@/assets/imgs/library_sound.svg"),
          title: this.$t("sound"),
          name: "Sound",
          route: "/dashboard/store/sound"
        },
        {
          image: require("@/assets/imgs/library_video.svg"),
          title: this.$t("video"),
          name: "Video",
          route: "/dashboard/store/video"
        }
      ];
    }
  },

  mounted: function() {},

  methods: {
    // navigateTo(item) {
    //   const queryParam = item.name;
    //   this.$router.push({
    //     path: "/Store",
    //     query: { param: queryParam }
    //   });
    // }
  }
};
</script>

<style scoped lang="css">
.imgtext {
  height: 130px;
  background-color: #a6cc39;
  opacity: 0.1;
  border-radius: 8px;
  position: relative;
  z-index: 0 !important;
}
.communityimg {
  position: absolute;
  top: 40%;
  left: 48%;
  transform: translate(-50%, -48%);
}
.v-image__image {
  z-index: 10 !important;
}
</style>
